import { useEffect, useMemo, useState } from "react";
import { useUser } from "@clerk/clerk-react";
import { backendFetch } from "@/lib/backend";

type FeatureFlag = {
  key: string;
  enabled: boolean;
  rollout: number;
  metadata?: Record<string, unknown>;
};

export const useFeatureFlags = () => {
  const { user } = useUser();
  const [flags, setFlags] = useState<FeatureFlag[]>([]);

  useEffect(() => {
    if (!user) {
      setFlags([]);
      return;
    }

    let cancelled = false;
    backendFetch("/feature-flags")
      .then((data) => {
        if (!cancelled) setFlags(Array.isArray(data.flags) ? data.flags : []);
      })
      .catch(() => {
        if (!cancelled) setFlags([]);
      });

    return () => {
      cancelled = true;
    };
  }, [user]);

  return useMemo(() => ({
    flags,
    isEnabled: (key: string) => Boolean(flags.find((flag) => flag.key === key)?.enabled),
  }), [flags]);
};
